import React from 'react'

import useCurrentQuestion from '@hooks/useCurrentPage'
import MoveButtonView from '@components/Button/MovePageButton/MoveButtonView'

type MovePageButtonProps = {
  isVisible: boolean
  isBackward: boolean
}

const MovePageButtonContainer: React.FC<MovePageButtonProps> = ({ isVisible, isBackward }) => {
  const { nextPage, prevPage } = useCurrentQuestion()
  const props = {
    isVisible,
    isBackward,
    movePageHandler: isBackward ? prevPage : nextPage,
  }
  return <MoveButtonView {...props} />
}

export default MovePageButtonContainer
